import script from "./participatingInstitutions.vue?vue&type=script&lang=ts&setup=true"
export * from "./participatingInstitutions.vue?vue&type=script&lang=ts&setup=true"

import "./participatingInstitutions.vue?vue&type=style&index=0&id=e2fe6828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2fe6828"]])

export default __exports__